var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChadcry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 603.03 425.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-2, .cls-6 {\n        fill: #a1a0a0;\n      }\n\n      .cls-2, .cls-8 {\n        stroke: #a09e9f;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: #626464;\n      }\n\n      .cls-3, .cls-10 {\n        fill: #626363;\n      }\n\n      .cls-4 {\n        fill: #626464;\n      }\n\n      .cls-11 {\n        fill: #b2b2b2;\n      }\n\n      .cls-11, .cls-10 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: #d4d4d4;\n        stroke: #d4d4d4;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        stroke: #a09f9f;\n      }\n\n      .cls-7 {\n        fill: #494849;\n      }\n\n      .cls-7, .cls-9 {\n        stroke: #484848;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5-5",
    "data-name": "Layer 5-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4-6",
    "data-name": "Layer 4-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M258.01,80.43l-34.95,124.98-9.3,28.18s-45.06,9.92-59.89,24.76c-14.83,14.84-8.81,5.19-16.29,18.41-3.5,6.19-9.93,28.6-12.84,50.89-3.3,25.33-2.86,50.45-2.86,50.45l185.99,44.27,173.26-23.82-33.53-135.42-83.58-30.99,2.97-151.47-89.27-24.04-19.7,23.78v.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M337.62,209.03l-20.02,3.18-15.63-1.03-39.93-27.92,1.35,29.79s16.81,24.49,23.61,25.7c6.8,1.2,19.74,3.24,28.68,2.13s15.16-2.56,15.16-2.56l-4.47,27.98s-2.1,14.03.72,18.43l8.48-9.06,12.26-2.28,21.42-6.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M383.91,265.34l25.54-5.72s18.92.15,22.07,2.86,18.93,32.58,21.7,46.48c3.17,15.85-.93,44.15,3.9,56.95s18.32,20.36,18.32,20.36l16.47-4.9,6.64-8.37-15.77-50.06-11.53-32.61-5.78-11.85-10.88-14.24-13.79-10.48-21.21-12.21-35.68-9.4v33.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M344.17,306.73s-10.75,40.95-4.25,65.44c2.24,8.45-19.07,14.1-19.07,14.1l-19.36-6.43,29.47-54.52,13.21-18.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M290.23,218.37s.19,29.72-13.51,39.88-20.77,8.56-13.78,10.31c21.87,5.47,29.75,7.55,29.75,7.55l-38.02-3.86-16.56-3.57-1.29-47.57,53.41-2.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M427.9,299.19s2.31,40.26,9.15,50.2c8.92,12.97,17.51-7.48,17.51-7.48l26.56,46.66-72.27-2.3-19.35-14.04c7.47-.22,15.34-9.98,23.13-18.03l15.27-55.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.7,259.45s10.25-4.03,13.28-9.78,6.34-10.79,6.34-10.79l1.81,26.93-21.42-6.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M181.56,287.5s15.08,32.48,14.56,54.03,0,51.97,0,51.97l27.43-4.92-8.02-35.2s-17-51.74-28.7-61.61c-5.19-4.38-5.28-4.26-5.28-4.26h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "290.9 144.11 282.81 195.66 305.36 209.69 304.72 180.25 307.46 144.11 290.9 144.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "354.7 140.98 358.66 163.48 357.57 187.48 365.04 179.32 364.17 138.47 354.7 140.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M337.62,85.99s-8.35-1.06-12.43,5.1-17.72,22.93-17.72,22.93c0,0-33.71,20.34-33.48,26.96s-1.2,17.89,13.58,19.23c0,0-5.63,6.68-9.95,10.77s-5.45,11.76-3.63,14.73,11.06,13.63,11.06,13.63l-33.07-20.03,5.9-75.09,60.59-32.19,19.16,13.96h-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.92,86.82s4.69-2.09,7.11,0,9,17.23,11.54,18.31,10.07,3.07,10.07,3.07l2.26-21.38-24.54-11.45-6.44,11.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M332.02,188.87s2.8-3.36,5.23-3.55,5.61,2.71,5.61,2.71l-6.31-7.57-4.53,8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.86,129.69s-.49,11.49.41,15.31,2.47,17.97,2.47,17.97l5.84-9.59s-6.38-12.52-6.48-15.6-2.23-8.1-2.23-8.1h-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "278.78 253.59 275.65 273.77 279.06 299.29 284.9 301.21 291.62 270.36 283.81 242.33 278.78 253.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M313.22,261.51s1.07,12.07,2.44,14.16,6.6,8.02,6.6,8.02l-10.52,23.93-4.57-2.88,6.05-43.23h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5-6",
    "data-name": "Layer 5-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M204.65,123.02l12.12,25.67-2.36,18.47-15.94,10.67-7.88-2.58,7.88,6.62h11.13l-13.47,15.55-9.29,15.85,3.21,12.18,6.08,6.82c-.8-4.2,5.28-20.75,15.96-22.61,0,0-2.73,15.47,2.05,20.32s10.57,23.62,10.57,23.62c0,0,35.14-5.58,34.72-24.31-.42-18.74.26-45.71.26-45.71l5.8-19.64,15.72-4.02-10.03-1.32-7.99-11.45s2.09-17.32,2.9-20.81,5.83-9.24,5.83-9.24c0,0,9.7-1.56,17.13-6.38,8.37-5.43,13.46-9.46,13.46-9.46l8.33-17.63,28.19-3.81s11.12-1.84,17.67,4.26,8.44,23.6,17.78,24.48c9.34.88,16.85,9.21,9.08-1.99s-15.93-45.43-19.14-50.85-28.54-18.57-35.96-19.24c-10-.91-11.68,10.11-11.68,10.11,0,0-19.1-9.93-34.55-9.59s-36.19,13.51-48.09,25.5c-8.34,8.4-11.47,12.05-11.47,12.05l3.05,21.18-15.63,11.35-5.45,15.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M348.06,201.89s-11.76,22.92-8.63,38.88c3.22,16.42,7.76,7.42,7.76,7.42l2.89-6.88,18.98,21.04,14.45-16.49s8.19-19.03,9.54-27.49,1.99-20.5,1.99-20.5l-23.17-19.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.65,37.85s11.02,4.48,16.27,9.38c3.73,3.48,5.3,7.78,5.3,7.78,0,0-10.21-3.92-17.02-3.83s-11.16,4.06-11.16,4.06c0,0,5.53-1.82,13.08-.11,6.06,1.37,16.13,3.98,16.8,10.37.67,6.39-3.16,20.07-3.16,20.07l14.33-3.39,11.95,1.75c6.57-3.78,12.5-4.14,18.11-2.74,0,0-1.45-19.24-5.59-18.91s-7.68,8.58-7.68,8.58l-6.25,8.15s4.6-6.61,4.9-11.11-10.99-13.89-2.89-16.75,10.79-1.83,10.79-1.83c0,0-11.12-3.2-21.74.95-3.08,1.2-4.58,2.25-4.58,2.25,0,0,11.07-11.96,18.1-12.67l-17.27-3.36-5.5,10.25-26.79-8.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M368.37,178.94s-3.02-58.16,3.5-53.6,5.02-10.88,5.02-10.88c0,0,5.97-3.57-2.1-3.3s-6.85-5.19-6.85-5.19c0,0-11.12-19.35-12.57-29.06s-2.49-13.52-2.49-13.52c7.65,1.76,3.65,3.23,9.39,5.43s4.9-12.9,4.9-12.9c1.99,3.04-1.59,12.27,11.67,17.87,17.23,7.27,3.99,26.31,6.11,28.98,0,0,15.52,14.38,13.42,33.55-1.57,14.33-6.38,6.19-8.35,13.97s-5.08,17.75.46,23.62c8.64,9.15,21.85-.63,21.85-.63,0,0-4.48,10.28-10.82,12.28s-16.04-.26-16.04-.26c0,0,17.4,13.7,20.55,22.65,2.44,6.93-6.45,22.65-6.45,22.65,0,0,3.51-8.55,1.5-13.5-1.13-2.77-7-6.85-7-6.85,0,0,3.66-4.75.6-10.38-3.27-6.02-8.03-9.39-8.03-9.39,0,0,.15,7.91-1.41,12.06-4.65,12.4-17.75,16.24-17.75,16.24,0,0,5.57-8.56,6.55-20.94s-5.66-18.92-5.66-18.92c-2.36,14.75-11.09,15.12-19.84,27.32s-7.33,10.51-7.33,10.51l-.52-6.46,3.87-4.08,21.41-27.99-.94-38.26,5.83-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.81,242.71s8.67,7.25,20.07,13.11c3.1-.9,11.22-6.48,10.82-11.83-.74-9.78,9.31-22.08,9.31-22.08,0,0-6.55,15.35-6.38,21.45s8.78,23.8-8.63,32.71-14.54,5.45-14.54,5.45c0,0,7.47-7.57,8.32-15.24s-14.24-10.19-17.92-17.86c-1.5-3.12-1.05-5.73-1.05-5.73v.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.64,236.47s-.2,6.27,2.24,9.87,5.8,3.75,5.8,3.75l5.06,9.41s-9.61-4.59-10.67-8.33-2.43-14.7-2.43-14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.48,211.18s2.66,18.79,8.64,23.88c7.12,6.05,2.28,17.12,2.28,17.12,0,0,27.42-8.86,30.48-25.63,1.34-7.36-9.17-27.14-3.71-38.35,2.74-5.64,14.6-23.41,14.6-23.41l-4.08,18.76,9.28,38.36s8.48,17.4.5,26.07c-7.43,8.06-14.73,11.52-14.73,11.52,0,0,9.13-12.67,3.27-18.27s-.85-.12-.85-.12c0,0-10.59,10.45-15.95,16.37s-3.9,13.08-1.71,16.8,6.49,6.68,6.49,6.68c0,0-18.05-.95-22.92-6.02s-10.98-13.18-9.55-28.17-4.56-23.05-2.04-35.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.37,185.12s15.34-9.54,19.5-12.54c4.83-3.48,18.41-24.59,18.41-24.59,0,0,8.08,14.92,15.76,15.77,2.18.24-15.01,24.89-14.84,27.29.34,4.75,2.44-11.43-12.58-7.49-11.15,2.92-18.22,18.65-18.22,18.65,0,0-.36-10.75,2.42-17.39,0,0-7.14,1.33-12.3,4.35-6.57,3.85-10.4,8.25-10.4,8.25l12.25-12.3h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 393.34,
    y1: 105.13,
    x2: 386.24,
    y2: 108.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-6",
    "data-name": "Layer 2-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M338.64,208.66c0,5.89.8,9.21.8,9.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325.63,266.3c.88-8.99,9.96-47.94,9.96-47.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327.98,283.69s6.74-7.55,8.4-7.55,29.78-6.5,32.98-8.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M408.85,260.45c-8.39,3.27-21.87,5.36-21.87,5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M392.01,235.06s39.01,8.94,47.22,16.99,20.86,14.85,33.87,50.63c13.01,35.78,24.04,67.62,24.04,67.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M428.2,296.78s-9.76,49.44-17.89,59.84-20.82,15.61-20.82,15.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M335.18,315.47s-5.06,13.16-5.21,21.7-.05,33.15-.05,33.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M341.21,159.93s1.48-.22,2.06.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M262.04,183.26s30.35,20.59,41.47,27.22c2.93,1.75,32.19-.07,35.12-1.82,11.12-6.63,27.17-30.33,27.17-30.33,0,0-2.54-26.15-1.97-39.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M276.71,218.37s12.93,38.95,14.19,47.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.46,283.69s-12.46-7.55-15.52-7.55-45.38-3.71-51.28-5.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M215.13,265.82s-13.48-2.1-21.87-5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M210.1,235.06s-46.1,13.44-54.31,21.49c-8.21,8.05-11.52.56-24.53,36.34-13.01,35.78-8.71,79.33-8.71,79.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.56,285.7c22.02,22.39,36.14,72.75,36.27,75.03.79,13.18,5.72,26.1,5.72,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M332.53,160.69s-1.48.04-2.06.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M334.77,122.7c-1.13.1-5.24,1.4-5.81,2.86s-5.18,11.94-5.18,11.94c0,0-3.13,4.19-7.49,5.22s-19.77,2.38-26.05.33-6.61-9.29-6.61-9.29l-1.38-10.73,9.81-7.57s24.91-.55,29.66.98,5.42,2.66,5.42,2.66c0,0,3.64-1.86,7.06-1.49,3.09.33,6.09,1.1,6.09,1.1,0,0-.06-2.24,4.68-4.6s26-5.54,26-5.54l9.81,5.85-1.38,10.98s-.33,7.29-6.61,10.44-17.38,3.87-21.74,4.17c-3.85.26-6.3-2.49-7.43-3.66,0,0-4.39-9.82-4.97-11.18s-2.75-2.55-3.87-2.45v-.02h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M310.85,185.71s11.48-11.16,14.2-10.88,8.12,1.5,11.82,1.5,4.77-3.4,6.4-3.4,9.83,3.94,10.9,7.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M331.5,187.48c2.41-4.91,5.37-6.67,5.37-6.67,0,0,4.66,2.47,5.37,5.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M290.23,143.04s-8.33,42.5-7.42,52.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.46,144.11s-1.39,21.1-1.9,29.92c-.5,8.82,0,36.91,0,36.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M354.18,139.97s2.86,18.18,3.16,22.42c.82,11.64-.84,28.48-.84,28.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "270.39 122.66 282.24 123.02 292.05 115.45 282.74 115.39 270.39 122.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M298.36,108.55s6.39,1.22,12.5,0,15.5-6.19,15.5-6.19c0,0,4.01,4.62,2.9,6.73s-13.31,5.87-18.4,6.08-23.18-.66-23.18-.66l10.68-5.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M344.02,101.25c1.38,0,5.27,3.9,9.69,4.73s14.62,1.77,14.62,1.77l-4.55,2.89s-19.93.79-21.54-3.28,1.77-6.11,1.77-6.11h.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hair-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M387.91,104.22c-1.35-2.17-2.21-4.08-2.21-5.83,0-4.87,8.26-10.24,3.09-16.98s-14.98-10.89-17.75-18.08c-6.92-17.98-22.44-20.76-38.65-26.46-13.59-4.77-15.6,9.71-15.6,9.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M344.56,206.22s-7.57,20.37-6.9,33.66c.62,12.06,7.42,21.74,18.68,21.87,0,0-7.76-7.21-7.76-12.22s2.82-8.03,2.82-8.03c0,0-.7,4.34,3.63,10.9s16.07,8.51,14.33,15.25-10.32,14.25-10.32,14.25c0,0,20.1,3.09,27.94-16.09,6-14.66-1.71-18.39.32-26.92s6.65-7.83,5.65-28.02c0,0,16.05,10.49,2.46,23.1,0,0,11.91-3.19,12.04-19.17s-13.6-23.25-23.35-30.97c0,0,11.95,4.82,20.89.49s7.86-17.45,7.86-17.45c0,0-7.09,13.33-15.48,10.08s-13.52-14.75-7.13-23.06c10.03-13.08,13-25.75,7.58-35.09-2.19-3.78-4.6-7.05-6.68-9.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M379.51,90.82c.92,20.21,16.21,12.09,16.21,12.09-10.34,15.68-24.04,8.61-31.27-.78-7.22-9.39-10.22-36.45-11.56-38.73s-3.3-3-8.67.56c-5.37,3.56-5.59,22.86-5.59,22.86,0,0,4.1-5.9,10.22-5.28s7.85,2.53,7.85,2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M316.79,46.59s-7.86-5.65-21.77-9.4c-18.95-5.11-40.98,5.35-50.12,13.25-5.83,5.04-16.75,14.23-21.92,20.97-5.17,6.74,2.98,18.45,1,22.9-4.18,9.36-11.11,7.06-16.52,16.4-5.42,9.34-4.23,16.6,4.98,30.27,9.21,13.67-1.09,30.61-9.48,33.86s-17.6-5.82-17.6-5.82c0,0,2.84,7.45,11.78,11.78s17.6-2.44,17.6-2.44c-9.75,7.72-28.15,21.3-28.01,37.27s12.26,21.96,12.26,21.96c-7.98-15.68,13.12-27.94,13.12-27.94-3.71,9.12-4.85,15.97.69,30.14,3.19,8.17-3.65,11.37,2.35,26.03,7.85,19.18,33.96,15.87,33.96,15.87,0,0-7.32-5.7-9.05-12.45-1.74-6.75,2.72-10.28,7.05-16.84s10.58-11.1,10.58-11.1v8.55c0,5.01-5.99,10.55-5.99,10.55,11.26-.14,22.3-12.46,22.91-24.52.68-13.29-9.45-27.23-11.98-41.34s.56-20.85,4.17-29.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M274.58,93.96c-1.27,20.21-26.39,14.69-26.39,14.69,14.24,15.68,42.6,6.65,52.56-2.74s14.18-39.56,16.03-41.83,3.67-2.8,11.07.76c7.4,3.56,10.78,21.98,10.78,21.98,0,0-4.22-4.26-12.65-3.64s-15.94,4.99-15.94,4.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M252.89,154.64s6.36,8.58,13.88,9.92c9.43,1.67,20.21-5.91,20.21-5.91,0,0-11.64,2.13-16.92-3.15s-5.07-11.87-4.78-18.81,8.26-19.54,8.26-19.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.01,127.29s-.72,12,4.75,13.71,14.23.81,14.23.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.89,127.52s2.47,8.38,5.44,9.89,14.92-.94,14.92-.94"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 358.66,
    y1: 117.25,
    x2: 347.47,
    y2: 133.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 368.37,
    y1: 116.2,
    x2: 354.7,
    y2: 136.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 301.34,
    y1: 119.26,
    x2: 289.07,
    y2: 137.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 309.74,
    y1: 119.99,
    x2: 295.31,
    y2: 141.21
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hands_Color",
    "data-name": "Hands Color"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "259.24 300.22 256.45 275.67 263.08 249.74 269.01 240.5 278.41 243.48 275.87 269.02 275.53 293.43 259.24 300.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "289.21 284.73 293.03 264.55 308.49 273.85 309.26 288.97 289.21 284.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "322.25 264.55 325.63 277.92 325.63 291.3 337.62 277.92 338.64 265.82 331.5 256.25 325.63 257.96 322.25 264.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M493.51,319.7s-20.32,27.32-20.29,31.34.4,24.36.4,24.36l25.7,24.15,22.97-20.22s7.36-18.08,13.01-24.64,26.98-30.59,26.98-30.59c0,0,2.02-11.42,4.54-14.89s11.8-21.75,11.8-21.75l4.05-27.59-5.75-3.04-8.31,6.37-3.22,9.65-7.91-21.27-7.44-.99-3.29,5.09,3.5,23.85-8.05,19.67-3.01,3.49.66-25.88-7.2-13.28-7.23-11.74-6.49,1.31-4.37,6.03,5.17,15.54,3.62,9.27-6.1,20.23h-4.52l-13.11-19.54-6.22-11.94-8.14-5.14-5.41,5.43,2.47,8.02,5.76,15.37,4.97,9.15.44,14.18h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "264.3 246.27 260.58 259.5 270.85 256.87 275.65 242.6 271.81 240.5 264.3 246.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.07,269.63s-1.95,14.06-6.99,21.67c-3.66,5.52-8.49,20.73-8.96,24.16s-6.02,18.1-6.02,18.1c0,0-6.62-9.45-5.54-16.14s3.09-16.05,3.09-16.05l-4.8,6.69-4.87-1.34s5.43-22.9,5.43-27.24-.1-9.57-.56-11.84l2.04-14.07s-2.2,7.57-3.64,10.96-2.55,18.72-3.28,21.15-8.73,20.12-9.39,23.51-4.3,28.36-7.78,36.02c0,0,10.42-25.04,18.64-31.38,0,0,1.23,20.96-1.38,26.64s-19.26,40.76-19.26,40.76l19.91-1.92,13.91-34.6,15.45-21.8,6.83-13.73,6.21-9.54,2.12-25.9-4.73-1.88-6.74,8.15.29-10.41.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.66,297.87s-2.23,7.9-3.84,9.88,3.84,23.69,3.84,23.69l6.91-11.34-7.44-10.89.54-11.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M275.87,269.02c-4.46,5.5-5.74,8.05-5.74,8.05,0,0,2.59,9.23,2.76,14.23s2.07,9.91,2.07,9.91l4.1-.2-3.54-13.52.35-18.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M499.63,284.62s-1.03,7.67-1.07,8.99,7.52,18.82,7.52,18.82l9.08,8.41.76-14.75-10.59-10.59-5.69-10.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M539.86,276.81s-1.3,4.58-3.17,5.96c-2.47,1.82-4.82,21.1-3.25,27.39s7.92,12.67,6.41,16.85c-8.28,22.91-22.06,31.42-27.26,45.21-4.86,12.88-11.97,30.16-11.97,30.16l21.67-19.63v-3.42l16.9-31.64,23.09-23.59s1.14-13.83,4.28-17.23,12.06-19.4,12.06-19.4l4.05-27.59-5.75-3.04s-8.13,7.1-9.83,11.56l-1.7,4.46s2.26,2.71-1.16,10.72c-18.64,43.68-12.61-2.04-12.61-2.04l-13.78,28.84,2.01-33.57h.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M517.09,345.94s7.16-9.74,8.39-13.53,0-11.57,0-11.57l-2.38,12.11-6.01,12.99h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hands"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M238.11,373.28s-6.46-28.01-11.17-31.94c0,0-2.62-23.3-4.71-28.28,0,0,1.83-19.11,0-24.35,0,0,7.72-2.81,12.31,0,3.58,2.19,9.81,8.79,5.45,20.31l8.2,11.1,10.18-17.44-2.62-22.36,2.62-17.2,7.33-20.8c5.66-5.02,14.4-.42,14.17,5.18-.18,4.46-3.96,15.75-3.96,18.78s-.26,17.39-.26,17.39c0,0,2.56,16.28,4.42,17.33s4.75.52,4.75.52c0,0,5.4-19.37,5.58-22.78s2.01-12.46,2.01-12.46l8.67-23.97s7.45-5.35,13.06,1.61c2.14,2.65-2.69,23.28-2.39,25.91s-.88,17.82-.88,17.82c0,0-4.55,17.65-3.39,18.25s4.27,1.7,4.27,1.7c0,0,8.94-16.81,9.98-18.91s2.76-14.92,2.69-17.02-3.06-3.76-2.95-8.56c.19-7.96,10.05-6.89,10.05-6.89,0,0,8.12,9.43,7.94,11.78s.63,25.66.63,25.66c0,0-9.98,16.76-9.72,19.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.46,379.34s8.77-24.7,14.38-33.92c7.1-11.66,16.03-22.46,16.03-22.46,0,0,4.75-17.46,11.38-23.21l1.55-26.09s-3.65-4.89-7.42,0-3.94,9.06-3.94,9.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M472.26,373.28s-5.05-17.93,7.79-36.36c4.37-6.27,13.46-17.21,13.46-17.21,0,0-.48-12.46-1.58-15.6-.86-2.46-5.3-10.37-5.3-10.37,0,0-3.13-13.26-6.26-16.96s3.76-10.27,6.57-9.33,9.7,6.85,12.21,16.25c0,0,6.57,12.85,9.7,15.98s7.82,6.25,7.82,6.25c0,0,6.88-17.2,5.95-23.77s-8.14-14.28-8.14-21.69,8.76-9.6,10.95-8.67,11.33,20.82,15.09,24.57c0,0-2.55,26.33-1.94,29.55.8,4.28,4.38,6.27,4.38,6.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M522.3,379.34s5.87-17.14,18.15-31.16c5.49-6.27,22.48-24.77,22.48-24.77,0,0,.63-7.77,4.48-15.39,4.43-8.76,11.22-20.54,11.22-20.54,0,0,.63-22.41,4.38-27.01,0,0-2.06-4.44-6.99-3.5-8,1.53-10.77,15.12-10.77,15.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M556.41,315.63s-1.13-4.79,3.08-14.02c2.88-6.32,9.13-22.28,9.13-22.28,0,0-10.01-20.44-10.33-27.74,0,0-7.76-5.4-12.21,3.27-2.09,4.07,5.15,25.15,5.15,25.15,0,0-8.27,21-12.03,22.68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChadcry);
export default __webpack_public_path__ + "static/media/chadcry.3bbea69d9cdf9d3efa1d0e90f4513fc3.svg";
export { ForwardRef as ReactComponent };